import type { ListenerEffectAPI, PayloadAction } from '@reduxjs/toolkit';
import { makeTreeId } from '../../../utils/tree/ids';
import { updateData } from '../tree';
import { resetTreeSorting } from './index';
import type { AppDispatch, RootState } from '../../index';

export const resetTreeSortingListenerOptions = {
  actionCreator: resetTreeSorting,
  effect: async (
    action: PayloadAction<{ catalogId: string }>,
    listenerApi: ListenerEffectAPI<RootState, AppDispatch>,
  ) => {
    const { dispatch, getOriginalState } = listenerApi;
    const { catalogId } = action.payload;
    const originalState = getOriginalState();
    const originalTree = originalState.treeSort.originalTree;

    if (originalTree.length > 0) {
      const treeId = makeTreeId(null, catalogId);
      dispatch(updateData(treeId, originalTree));
    }
  },
};
